import { SITE_URL } from "./api"

export const IS_LOCAL =
  SITE_URL.hostname === "localhost" || SITE_URL.hostname === "127.0.0.1"

export const IS_VERCEL =
  SITE_URL.hostname.endsWith(".dev.privatesea.io") ||
  SITE_URL.hostname.endsWith(".vercel.app") ||
  SITE_URL.hostname.endsWith("os2-web.prod.privatesea.io")
